import { render, staticRenderFns } from "./ABCompare.vue?vue&type=template&id=1a1c3d38&scoped=true"
import script from "./ABCompare.vue?vue&type=script&lang=js"
export * from "./ABCompare.vue?vue&type=script&lang=js"
import style0 from "./ABCompare.vue?vue&type=style&index=0&id=1a1c3d38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c3d38",
  null
  
)

export default component.exports